import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, withModifiers as _withModifiers, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("h5", { class: "accent-3 text-uppercase" }, "Prenumerera på nya släpp", -1)
const _hoisted_2 = /*#__PURE__*/_createElementVNode("p", null, "Så fort vi lägger ut nya objekt så får du ett mail.", -1)
const _hoisted_3 = { class: "d-flex w-100 gap-2" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("label", {
  for: "newsletter",
  class: "visually-hidden"
}, "Epost", -1)
const _hoisted_5 = ["disabled", "onClick"]

import { ref } from 'vue';
    import { newsletterApi } from '@/services/newsletter.service';

    
export default /*#__PURE__*/_defineComponent({
  __name: 'Newsletter',
  setup(__props) {

    const email = ref<string>('');
    const isSubmitting = ref<boolean>(false);

    const subscribe = async function () {
        isSubmitting.value = true;
        const res = await newsletterApi.add(email.value);
        if (res) {
            email.value = '';
            alert('Du prenumererar nu!')
        }
        else {
            alert('Något gick snett. Kontrollera att e-posten följer formatet `namn@namn.se`.')
            isSubmitting.value = false;
        }
    }

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("form", null, [
    _hoisted_1,
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, [
      _hoisted_4,
      _withDirectives(_createElementVNode("input", {
        id: "newsletter",
        type: "email",
        class: "form-control",
        placeholder: "Epostadress",
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((email).value = $event))
      }, null, 512), [
        [_vModelText, email.value]
      ]),
      _createElementVNode("button", {
        class: "btn btn-primary",
        type: "button",
        disabled: isSubmitting.value,
        onClick: _withModifiers(subscribe, ["prevent"])
      }, " PRENUMERERA ", 8, _hoisted_5)
    ])
  ]))
}
}

})